"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
const react_1 = __importStar(require("react"));
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const native_1 = require("@react-navigation/native");
const drawer_1 = require("@react-navigation/drawer");
const react_native_1 = require("react-native");
const pages_1 = require("./components/pages");
const native_base_1 = require("native-base");
const Dashboard_1 = require("./features/dashboard/mobile/Dashboard");
const Dashboard_web_1 = require("./features/dashboard/web/Dashboard.web");
const RootNavigation_1 = require("./helper/RootNavigation");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const ResetPassword_1 = require("./components/pages/ResetPassword/ResetPassword");
const NavigationDrawer_1 = require("./components/organisms/NavigationDrawer/NavigationDrawer");
const NavigationFunctions_1 = require("./components/organisms/NavigationDrawer/NavigationFunctions");
const atome_1 = require("./components/atome/");
const react_jwt_1 = require("react-jwt");
const hooks_1 = require("./store/hooks");
const reducers_1 = require("./store/reducers");
const User_service_1 = __importDefault(require("./services/User.service"));
const NavigationReducer_1 = require("./helper/NavigationReducer");
const UnavailableAppointment_1 = __importDefault(require("./components/pages/Profile/OnlineAppointment/UnavailableAppointment/UnavailableAppointment"));
const MyPharmacy_web_1 = require("./components/pages/MyPharmacy/Web/MyPharmacy.web");
const MyPharmacy_1 = require("./components/pages/MyPharmacy/Mobile/MyPharmacy");
const PharmacyList_1 = require("./components/pages/MyPharmacy/Mobile/PharmacyList");
const PharmacyList_web_1 = require("./components/pages/MyPharmacy/Web/PharmacyList.web");
const PharmacyConfirmation_1 = require("./components/pages/MyPharmacy/Mobile/PharmacyConfirmation");
const PharmacyDetails_1 = require("./components/pages/MyPharmacy/Mobile/PharmacyDetails");
const PharmacyDetails_web_1 = require("./components/pages/MyPharmacy/Web/PharmacyDetails.web");
const PharmacyCreation_web_1 = require("./components/pages/MyPharmacy/Web/PharmacyCreation.web");
const PharmacyCreation_1 = require("./components/pages/MyPharmacy/Mobile/PharmacyCreation");
const PharmacyPage = react_native_1.Platform.OS === 'web' ? MyPharmacy_web_1.MyPharmacy : MyPharmacy_1.MyPharmacy;
const PharmacyListPage = react_native_1.Platform.OS === 'web' ? PharmacyList_web_1.PharmacyList : PharmacyList_1.PharmacyList;
const PharmacyDetails = react_native_1.Platform.OS === 'web' ? PharmacyDetails_web_1.PharmacyDetails : PharmacyDetails_1.PharmacyDetails;
const PharmacyCreation = react_native_1.Platform.OS === 'web' ? PharmacyCreation_web_1.PharmacyCreation : PharmacyCreation_1.PharmacyCreation;
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const RegisterProcedure_1 = require("./components/pages/Register/RegisterProcedure/RegisterProcedure");
const package_json_1 = require("../package.json");
const Drawer = (0, drawer_1.createDrawerNavigator)();
const DashboardPage = react_native_1.Platform.OS === 'web' ? Dashboard_web_1.Dashboard : Dashboard_1.Dashboard;
const linking = {
    prefixes: ['http://localhost:8080'],
    config: {
        screens: {
            Home: '',
            ConfirmTerms: 'confirm-terms',
            ConfirmAgbs: 'confirm-agbs',
            ConfirmPrivacyPolicy: 'confirm-privacy-policy',
            Dashboard: 'Dashboard',
            Contact: 'contact',
            Calendly: 'contact/calendly',
            CalendlyWebview: 'contact/calendlyWebview',
            CaseHistoryOverview: 'profile/case-history-overview',
            Splash: 'profile/splash',
            FirstPresentation: 'profile/first-presentation',
            SecondaryDiagnosis: 'profile/secondary-diagnosis',
            Documents: 'profile/documents',
            FurtherQuestion: 'profile/further-question',
            Medication: 'profile/medication',
            LifeQuality: 'profile/life-quality',
            OnlineAppointment: 'profile/online-appointment',
            OnlineFirstAppointment: 'profile/online-first-appointment',
            OnlineFirstAppointmentSuccess: 'profile/online-first-appointment/success',
            AppointmentSuccess: 'profile/online-appointment/success',
            UnavailableAppointment: 'profile/online-appointment/unavailable',
            OfflineFirstAppointment: 'profile/offline-first-appointment',
            OfflineFirstAppointmentSuccess: 'profile/offline-first-appointment/success',
            RegisterProcedure: 'register',
            RegisterSuccess: 'register/success',
            Login: 'login',
            ForgotPassword: 'forgot-password',
            MyAccount: 'my-account',
            PharmacyPage: 'my-pharmacy',
            PharmacyListPage: 'pharmacy-list',
            PharmacyDetails: 'pharmacy-details',
            PharmacyConfirmaction: 'confirm-pharmacy',
            PharmacyCreation: 'create-pharmacy',
            UpdatePersonalData: 'update-personal-data',
            ResetPassword: 'reset-password',
            FollowPrescription: 'follow-prescription',
            ActivateAccount: 'activation',
        },
    },
};
const App = () => {
    const [isMounted, setMounted] = (0, react_1.useState)(false);
    const [isFirstTime, setIsFirstTime] = (0, react_1.useState)(false);
    const [toggleBarUp, setToggleBarUp] = (0, react_1.useState)(false);
    const [isFemale, setIsFemale] = (0, react_1.useState)(false);
    const [hasOtherDiseases, setHasOtherDiseases] = (0, react_1.useState)(false);
    const [showFUPRModal, setShowFUPRModal] = (0, react_1.useState)(false);
    const [userInfo, setUserInfo] = (0, react_1.useState)(null);
    const [state, reactDispatch] = (0, react_1.useReducer)(NavigationReducer_1.reactReducer, NavigationReducer_1.initialState);
    const authState = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const memoizedIsFemale = (0, react_1.useMemo)(() => isFemale, [isFemale]);
    react_native_1.StatusBar.setBarStyle('dark-content', true);
    if (react_native_1.Platform.OS === 'android') {
        react_native_1.StatusBar.setBackgroundColor('white');
    }
    const checkAuthenticated = async () => {
        const token = await async_storage_1.default.getItem('JWT');
        const user = await async_storage_1.default.getItem('User');
        const termAgree = await async_storage_1.default.getItem('TermsAgree');
        const privacyPolicyAgree = await async_storage_1.default.getItem('PrivacyPolicyAgree');
        const newsletterAgree = await async_storage_1.default.getItem('NewsletterAgree');
        if (token && user) {
            const decodedToken = (0, jwt_decode_1.default)(token);
            if (!(0, react_jwt_1.isExpired)(token) || (decodedToken && !('exp' in decodedToken))) {
                const auth = {
                    isAuthenticated: true,
                    isTermsAgree: termAgree === 'true',
                    isPrivacyPolicyAgree: privacyPolicyAgree === 'true',
                    isNewsletterAgree: newsletterAgree === 'true',
                    name: user,
                };
                dispatch((0, reducers_1.setAuth)(auth));
                User_service_1.default.information().then(r => {
                    if (r.error) {
                        console.log(r.message);
                    }
                    dispatch((0, reducers_1.setUserInformation)(r.data));
                });
            }
        }
        else {
            const auth = {
                isAuthenticated: false,
                isTermsAgree: termAgree === 'true',
                isPrivacyPolicyAgree: privacyPolicyAgree === 'true',
                isNewsletterAgree: newsletterAgree === 'true',
            };
            dispatch((0, reducers_1.setAuth)(auth));
        }
        const firstTime = await async_storage_1.default.getItem('FirstTime');
        if (firstTime === null) {
            setIsFirstTime(true);
        }
    };
    (0, react_1.useEffect)(() => {
        if (react_native_1.Platform.OS === 'web') {
            react_gtm_module_1.default.initialize({ gtmId: 'GTM-N9BLPHB' });
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (react_native_1.Platform.OS !== 'web') {
            const subscription = react_native_1.AppState.addEventListener('change', nextAppState => {
                if (nextAppState === 'active') {
                    checkAuthenticated();
                }
            });
            return () => {
                subscription.remove();
            };
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isMounted) {
            (async () => {
                await checkAuthenticated();
                // redirect user to /register if there is a deep link of : register/step-1
                if (react_native_1.Platform.OS === 'web') {
                    const initialUrl = await react_native_1.Linking.getInitialURL();
                    const urlEnding = initialUrl?.lastIndexOf('/');
                    const result = initialUrl?.substring(urlEnding + 1);
                    const correctUrl = initialUrl?.replace(result, '');
                    result === 'step-1' && window.location.replace(correctUrl);
                }
            })();
            setMounted(true);
        }
    }, [isMounted]);
    const BarTitle = (props) => {
        return (react_1.default.createElement(react_native_1.View, null, props.route.name === 'Dashboard' ||
            props.route.name === 'Contact' ||
            props.route.name === 'Login' ||
            props.route.name === 'RegisterProcedure' ||
            props.route.name === 'ForgotPassword' ||
            props.route.name === 'ConfirmTerms' ? (react_1.default.createElement(atome_1.Icon, { icon: "nowomed", size: 150 })) : (react_1.default.createElement(react_native_1.View, { style: [
                {
                    height: 35,
                    justifyContent: 'center',
                },
            ] },
            react_1.default.createElement(atome_1.Text, { style: [
                    {
                        fontSize: 20,
                        color: 'black',
                        fontFamily: 'Montserrat-Regular',
                    },
                ] }, props.options.title || 'No Title')))));
    };
    const BarButton = (props) => {
        return (react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: 20 } }, props.route.name === 'Dashboard' ||
            props.route.name === 'Login' ||
            props.route.name === 'Contact' ||
            (props.route.name === 'Documents' &&
                props.route.params?.page === 'my-documents') ||
            props.route.name === 'RegisterProcedure' ||
            props.route.name === 'MyAccount' ||
            props.route.name === 'PharmacyPage' ||
            props.route.name === 'PatientenTracking' ||
            props.route.name === 'TrackingSuccess' ||
            props.route.name === 'OfflineFirstAppointmentSuccess' ||
            props.route.name === 'OnlineFirstAppointmentSuccess' ||
            props.route.name === 'OnlineAppointmentSuccess' ? (react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, hitSlop: { top: 15, bottom: 30, left: 15, right: 15 }, onPress: () => props.navigation.openDrawer(), style: { marginTop: 7 } },
            react_1.default.createElement(atome_1.Icon, { icon: "menu", size: 25 }))) : (react_1.default.createElement(react_native_1.View, { style: { transform: [{ rotate: '90deg' }], marginTop: 17 } }, props.route.name !== 'Login' &&
            props.route.name !== 'ConfirmPrivacyPolicy' &&
            props.route.name !== 'ConfirmAgbs' &&
            props.route.name !== 'ConfirmTerms' ? (react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, hitSlop: { top: 15, bottom: 15, left: 15, right: 15 }, onPress: () => (0, NavigationFunctions_1.BackFunction)({
                isFemale: memoizedIsFemale,
                isFirstTime,
                hasOtherDiseases,
                state,
                prescriptionInfo,
                reactDispatch,
                setShowFUPRModal,
                ...props,
            }) },
            react_1.default.createElement(atome_1.Icon, { icon: "chevron", size: 25 }))) : null))));
    };
    const barAnim = (0, react_1.useRef)(new react_native_1.Animated.Value(-60)).current;
    (0, react_1.useEffect)(() => {
        if (!toggleBarUp) {
            react_native_1.Animated.timing(barAnim, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
        else {
            react_native_1.Animated.timing(barAnim, {
                toValue: react_native_1.Platform.OS === 'ios' ? -90 : -60,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    }, [toggleBarUp]);
    (0, react_1.useEffect)(() => {
        const handleBackButtonClick = () => {
            (0, RootNavigation_1.goBack)(state, reactDispatch, memoizedIsFemale, hasOtherDiseases, prescriptionInfo, setShowFUPRModal);
            return true;
        };
        react_native_1.BackHandler.addEventListener('hardwareBackPress', handleBackButtonClick);
        return () => {
            react_native_1.BackHandler.removeEventListener('hardwareBackPress', handleBackButtonClick);
        };
    }, []);
    const Bar = (props) => {
        return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
            react_1.default.createElement(react_native_1.Animated.View, { style: {
                    flex: 1,
                    transform: [{ translateY: barAnim }],
                    backgroundColor: 'white',
                } },
                react_1.default.createElement(react_native_1.View, { style: {
                        flex: 1,
                        paddingVertical: react_native_1.Platform.OS === 'ios' ? 0 : 10,
                        backgroundColor: 'white',
                        paddingBottom: 45,
                    } },
                    react_1.default.createElement(react_native_1.View, { style: { alignItems: 'flex-start' } },
                        react_1.default.createElement(BarButton, { ...props })),
                    react_1.default.createElement(react_native_1.View, { style: { alignItems: 'center' } },
                        react_1.default.createElement(BarTitle, { ...props }))))));
    };
    const resetState = () => {
        setUserInfo(null);
        setIsFemale(false);
        setToggleBarUp(false);
        setHasOtherDiseases(false);
        setIsFirstTime(false);
        reactDispatch({ type: '[RESET]', payload: {} });
    };
    const xApiKey = 'ZjExN2UzZGQtYjVjMy00ODlkLWI0ZWUtOTM0NWQzZDNjYzkz'; // Your project key
    const appInfo = {
        appId: 'com.nowomed.patients',
        appName: 'nowomedClinics',
        appVersion: `${package_json_1.version}`,
        platform: react_native_1.Platform.OS === 'android' ? 'android' : 'ios',
        environment: !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
            ? 'development'
            : 'production',
        appLanguage: 'de', //Your app language ex: en, es etc. Optional.
    };
    // Alert config is optional
    const alertConfig = {
        title: 'Please Update',
        updateButtonTitle: 'Update Now',
        laterButtonTitle: 'Later',
        onDismissCallback: () => {
            console.log('Dismiss');
        },
        onLaterCallback: () => {
            console.log('Later');
        },
    };
    /** {
      Platform.OS !== 'web'
        ? appUpgradeVersionCheck(appInfo, xApiKey, alertConfig)
        : null;
    } */
    return (react_1.default.createElement(native_base_1.NativeBaseProvider, null,
        react_1.default.createElement(native_1.NavigationContainer, { ref: RootNavigation_1.navigationRef, linking: linking },
            react_1.default.createElement(Drawer.Navigator, { drawerContent: props => (react_1.default.createElement(NavigationDrawer_1.NavigationDrawer, { ...props, resetState: resetState, setToggleBarUp: setToggleBarUp })), screenOptions: () => ({
                    header: props => react_1.default.createElement(Bar, { ...props }),
                    swipeEnabled: !!(authState.isAuthenticated &&
                        authState.isPrivacyPolicyAgree &&
                        authState.isTermsAgree),
                }) },
                react_1.default.createElement(Drawer.Screen, { name: "Home", component: pages_1.Home, options: { headerShown: false } }),
                react_1.default.createElement(Drawer.Screen, { name: "Login", options: { title: 'Login' } }, props => react_1.default.createElement(pages_1.Login, { ...props, setUserInfo: setUserInfo })),
                react_1.default.createElement(Drawer.Screen, { name: "ConfirmTerms", component: pages_1.ConfirmTerms, options: { title: 'Neue Nutzungsbedingungen' } }),
                react_1.default.createElement(Drawer.Screen, { name: "ConfirmAgbs", component: pages_1.ConfirmAgbs, options: { title: 'Neue AGBs' } }),
                react_1.default.createElement(Drawer.Screen, { name: "ConfirmPrivacyPolicy", component: pages_1.ConfirmPrivacyPolicy, options: { title: 'Neue Datenschutzerklärung' } }),
                react_1.default.createElement(Drawer.Screen, { name: "Dashboard", options: { title: 'Dashboard' } }, props => (react_1.default.createElement(DashboardPage, { ...props, setToggleBarUp: setToggleBarUp, setUserInfo: setUserInfo }))),
                react_1.default.createElement(Drawer.Screen, { name: "Contact", component: pages_1.Contact, options: { title: 'Kontakt' } }),
                react_1.default.createElement(Drawer.Screen, { name: "Calendly", component: pages_1.Calendly, options: { title: 'Calendly' } }),
                react_1.default.createElement(Drawer.Screen, { name: "CalendlyWebview", options: { title: 'Support-Termin vereinbaren' } }, props => react_1.default.createElement(pages_1.CalendlyWebview, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "Splash", options: { title: 'Patienten-Information' } }, props => react_1.default.createElement(pages_1.Splash, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "CaseHistoryOverview", options: { title: 'Ihre Angaben' } }, props => react_1.default.createElement(pages_1.CaseHistoryOverview, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "FirstPresentation", options: { title: 'Erstvorstellung' } }, props => (react_1.default.createElement(pages_1.FirstPresentation, { ...props, currentPage: state.firstPresentationIndex, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "SecondaryDiagnosis", options: { title: 'Nebendiagnosen' } }, props => (react_1.default.createElement(pages_1.SecondaryDiagnosis, { ...props, currentPage: state.secondaryDiagnosisIndex, setCurrentPage: reactDispatch, setOtherDiseases: setHasOtherDiseases, userInfo: userInfo }))),
                react_1.default.createElement(Drawer.Screen, { name: "Documents", component: pages_1.Documents, options: { title: 'Dokumente' } }),
                react_1.default.createElement(Drawer.Screen, { name: "Medication", options: { title: 'Medikation' } }, props => react_1.default.createElement(pages_1.Medication, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "FurtherQuestion", options: { title: 'Persönliche Angaben' } }, props => (react_1.default.createElement(pages_1.FurtherQuestion, { ...props, currentPage: state.furtherQuestionsIndex, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "LifeQuality", component: pages_1.LifeQuality, options: { title: 'Lebensqualität' } }),
                react_1.default.createElement(Drawer.Screen, { name: "OfflineFirstAppointment", options: { title: 'Termin buchen' } }, props => (react_1.default.createElement(pages_1.OfflineFirstAppointment, { ...props, currentPage: state.offlineFirstAppointmentIndex, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "OfflineFirstAppointmentSuccess", component: pages_1.OfflineFirstAppointmentSuccess, options: { title: 'Termin buchen' } }),
                react_1.default.createElement(Drawer.Screen, { name: "OnlineAppointment", options: { title: 'Online-Termin' } }, props => (react_1.default.createElement(pages_1.OnlineAppointment, { ...props, currentPage: state.onlineAppointmentIndex, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "UnavailableAppointment", options: { title: 'Online-Termin' }, component: UnavailableAppointment_1.default }),
                react_1.default.createElement(Drawer.Screen, { name: "AppointmentSuccess", component: pages_1.AppointmentSuccess, options: { title: 'Online-Termin' } }),
                react_1.default.createElement(Drawer.Screen, { name: "OnlineFirstAppointment", options: { title: 'Termin buchen' } }, props => (react_1.default.createElement(pages_1.OnlineFirstAppointment, { ...props, currentPage: state.onlineFirstAppointmentIndex, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "OnlineFirstAppointmentSuccess", component: pages_1.OnlineFirstAppointmentSuccess, options: { title: 'Termin buchen' } }),
                react_1.default.createElement(Drawer.Screen, { name: "MyAccount", options: { title: 'Mein Profil' } }, props => react_1.default.createElement(pages_1.MyAccount, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "PharmacyPage", options: { title: 'Meine Apotheke' } }, props => react_1.default.createElement(PharmacyPage, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "PharmacyListPage", options: { title: 'Apotheke wählen' } }, props => (react_1.default.createElement(PharmacyListPage, { ...props, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "PharmacyConfirmation", options: { title: 'Apotheke wählen' } }, props => (react_1.default.createElement(PharmacyConfirmation_1.PharmacyConfirmation, { ...props, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "PharmacyDetails", options: { title: 'Apotheke wählen' } }, props => react_1.default.createElement(PharmacyDetails, { ...props })),
                react_1.default.createElement(Drawer.Screen, { name: "PharmacyCreation", options: { title: 'Apotheke wählen' } }, props => (react_1.default.createElement(PharmacyCreation, { ...props, setCurrentPage: reactDispatch }))),
                react_1.default.createElement(Drawer.Screen, { name: "UpdatePersonalData", options: { title: 'Kontaktdaten bearbeiten' } }, props => (react_1.default.createElement(pages_1.UpdatePersonalData, { ...props, setUserInfo: setUserInfo }))),
                react_1.default.createElement(Drawer.Screen, { name: "RegisterProcedure", component: RegisterProcedure_1.RegisterProcedure, options: { title: 'Registrierung' } }),
                react_1.default.createElement(Drawer.Screen, { name: "RegisterSuccess", component: pages_1.RegisterSuccess, options: { title: 'Registrierung' } }),
                react_1.default.createElement(Drawer.Screen, { name: "ForgotPassword", component: pages_1.ForgotPassword, options: { title: 'Passwort vergessen' } }),
                react_1.default.createElement(Drawer.Screen, { name: "ResetPassword", component: ResetPassword_1.ResetPassword, options: { title: 'Passwort zurücksetzen' } }),
                react_1.default.createElement(Drawer.Screen, { name: "PatientenTracking", component: pages_1.PatientenTracking, options: { title: 'Therapie Monitoring' } }),
                react_1.default.createElement(Drawer.Screen, { name: "TrackingSuccess", component: pages_1.TrackingSuccess, options: { title: 'Therapie Monitoring' } }),
                react_1.default.createElement(Drawer.Screen, { name: "FollowPrescription", options: { title: 'Folgerezept' } }, props => (react_1.default.createElement(pages_1.FollowPrescription, { ...props, currentPage: state.followUpPrescriptionsIndex, setCurrentPage: reactDispatch, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal })))))));
};
exports.default = App;
